// apps/retreat-pwa/src/screens/WhatsNewScreen.tsx
import { useEffect } from 'react';
import { groupByMonth } from '../utils/updateUtils';
import { MetaStrip } from '../components/MetaStrip';
import { TEST_IDS } from '../testing/testIds';
import styles from './WhatsNewScreen.module.css';
import type { PlatformUpdate, UpdateCta, UpdateType } from '../types/updates';

const UPDATE_TYPE_LABEL: Record<UpdateType, string> = {
  feature:      'Feature',
  retreat:      'New Retreat',
  announcement: 'Announcement',
};

type Props = {
  updates: PlatformUpdate[];
  onBack: () => void;
  onCta: (cta: UpdateCta) => void;
  onMount: () => void;
};

export function WhatsNewScreen({ updates, onBack, onCta, onMount }: Props) {
  useEffect(() => { onMount(); }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const groups = groupByMonth(updates);

  return (
    <div className={styles.screen} data-testid={TEST_IDS.WHATS_NEW_SCREEN}>
      <MetaStrip label="What's New" onBack={onBack} />

      <div className={styles.feed}>
        {groups.length === 0 && (
          <p className={styles.empty}>No updates yet.</p>
        )}

        {groups.map((group) => (
          <section key={group.label} className={styles.group}>
            <div className={styles.monthLabel}>{group.label}</div>

            {group.updates.map((update) => (
              <div key={update.id} className={styles.card}>
                <div className={styles.badge}>
                  {UPDATE_TYPE_LABEL[update.type]}
                </div>
                <h2 className={styles.title}>{update.title}</h2>
                <p className={styles.body}>{update.body}</p>

                {update.cta !== null && update.ctaLabel !== null && (
                  <button
                    type="button"
                    className={styles.cta}
                    onClick={() => onCta(update.cta!)}
                  >
                    {update.ctaLabel}
                  </button>
                )}
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
